<template>
  <div v-if="text && displayText" class="spelling-suggestion" role="heading" aria-level="2">
    {{
      /* disabling this lint rule because it forces a line break inside the ELink
       * which causes a space to be rendered between the link and the question mark */
      /* eslint-disable vue/multiline-html-element-content-newline */
    }}
    {{ $t('web.spellingsuggestion') }}
    <ELink
      class="spelling-suggestion__link"
      color="result"
      :href="url"
      :title="displayText"
      rel="noopener"
      data-test-id="spelling-suggestion-link"
    >
      {{ displayText }}
    </ELink>?
  </div>
</template>

<script>
import { getUrlQuery } from '~~/common/js/universal/search';
import ELink from '~~/common/vue/components/link';

export default {
  name: 'ESpellingSuggestion',
  components: {
    ELink,
  },
  props: {
    text: {
      type: String,
      default: '',
    },
    displayText: {
      type: String,
      default: '',
    },
  },
  computed: {
    url() {
      const query = {
        ...getUrlQuery(this.$route.query, this.$store.state.user),
        q: this.text,
      };
      return this.$router.resolve({ query }).href;
    },
  },
};
</script>

<style lang="scss" scoped>
.spelling-suggestion {
  @extend %ellipsis;

  font-size: $font-l;
  padding: $space-s;

  @include desktop {
    padding: 0 $space-m;
  }
}
</style>
